import React from 'react';

import { createClassName } from 'utils/createClassName';

import './themeProviderStyles.scss';

type Props = {
  mode?:
    | 'onLight'
    | 'onDark'
    | 'adminNavigationTesting'
    | 'adminNavigationProd'
    | 'prodRegistraionComplete';
};

export const ThemeProviderComponent: React.FC<Props> = (props) => {
  const { children, mode = 'onLight' } = props;

  const className = createClassName('themeProvider')({ mode });

  return <div className={className}>{children}</div>;
};
